import { NASProductFareFragment, NASProductFragment, NASStatus } from '@websky/graphql';
import * as React from 'react';
import { EveryPortSelectedService } from '../../../../Checkout/store/everyPortServices/reducers';
import { LoungeSelectedService } from '../types';

interface LoungeAction {
	type: 'add' | 'remove';
	payload: LoungeSelectedService;
}

interface ClearOnSegmentAction {
	type: 'clearOnSegment';
	payload: string;
}

const LoungeReducer: React.Reducer<LoungeSelectedService[], LoungeAction | ClearOnSegmentAction> = (
	state = [],
	action
) => {
	if (action.type === 'add') {
		const { payload } = action as LoungeAction;

		if (!state.find(item => item.travellerId === payload.travellerId && item.product.id === payload.product.id)) {
			return [
				...state,
				{
					...payload
				}
			];
		}
	} else if (action.type === 'remove') {
		const { payload } = action as LoungeAction;

		return state.filter(item => item.travellerId !== payload.travellerId || item.product.id !== payload.product.id);
	} else if (action.type === 'clearOnSegment') {
		const { payload: segmentId } = action as ClearOnSegmentAction;

		return state.filter(item => item.product.segmentId.toString() !== segmentId);
	}

	return state;
};

export const useEveryPortState = (
	selectedServices: EveryPortSelectedService[],
	everyPortServices: NASProductFragment[]
) => {
	const [state, dispatch] = React.useReducer(LoungeReducer, selectedServices, selectedServices => {
		const state: LoungeSelectedService[] = [];

		selectedServices.forEach(service => {
			const product = everyPortServices.find(everyPort => everyPort.id === service.product.id),
				fare = product.fares.find(fare => fare.id === service.fare.id);

			service.orders.forEach(order => {
				state.push({
					travellerId: order.travellers.id,
					product: product,
					active: true,
					fare: fare,
					status: order.status
				});
			});
		});

		return state;
	});

	const setTraveller = (travellerId: string, product: NASProductFragment, fare: NASProductFareFragment) => {
		dispatch({
			type: 'add',
			payload: {
				travellerId,
				product,
				fare,
				status: NASStatus.New
			}
		});
	};

	const removeTraveller = (travellerId: string, product: NASProductFragment, fare: NASProductFareFragment) => {
		dispatch({
			type: 'remove',
			payload: {
				travellerId,
				product,
				fare
			}
		});
	};

	const clearSegment = (segmentId: string) => {
		dispatch({
			type: 'clearOnSegment',
			payload: segmentId
		});
	};

	return {
		state,
		setTraveller,
		removeTraveller,
		clearSegment
	};
};
